import { RoleVariantEnum } from 'common/graphql/types';
import { DCRType } from 'common/types/dcrTypes';
import { flatMap, includes } from 'lodash';

export const DCR_INTERNAL_ROLES = [RoleVariantEnum.DataChangeSupport, RoleVariantEnum.ProductSupport];

export interface DCRCreateAccessCheckParams {
    userRole: RoleVariantEnum;
    dcrTypeConfigs: DCRType[];
}

export interface DCRAccessCheckParams extends DCRCreateAccessCheckParams {
    viewPermissions: string[];
}

export const checkDCRAccess = ({ userRole, viewPermissions, dcrTypeConfigs }: DCRAccessCheckParams): boolean => {
    const hasViewPermissions = includes(viewPermissions, userRole);

    const hasOpenRole = includes(
        flatMap(dcrTypeConfigs, (type) => type.openRoles as RoleVariantEnum[]),
        userRole
    );

    const hasApproveRole = includes(
        flatMap(dcrTypeConfigs, (type) => flatMap(type.approveRoles, (role) => role.roleId as RoleVariantEnum[])),
        userRole
    );

    return includes(DCR_INTERNAL_ROLES, userRole) || hasViewPermissions || hasOpenRole || hasApproveRole;
};

export const checkDCRCreateAccess = ({ userRole, dcrTypeConfigs }: DCRCreateAccessCheckParams): boolean => {
    const hasOpenRole = includes(
        flatMap(dcrTypeConfigs, (type) => type.openRoles as RoleVariantEnum[]),
        userRole
    );

    return includes(DCR_INTERNAL_ROLES, userRole) || hasOpenRole;
};
